"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccessRole = void 0;
const store_1 = require("@app/store");
const react_redux_1 = require("react-redux");
const is_defined_1 = require("../is-defined");
const useAccessRole = (defaultPermission) => {
    const meAclWorkspaces = (0, store_1.useRootSelector)(({ me }) => me.acl?.workspaces, react_redux_1.shallowEqual);
    const workspaceId = (0, store_1.useRootSelector)(({ workspaceId }) => workspaceId, react_redux_1.shallowEqual);
    const aclWorkspaces = meAclWorkspaces && Object.keys(meAclWorkspaces);
    const currentWsPermissions = aclWorkspaces?.length && (0, is_defined_1.isValue)(workspaceId) ? meAclWorkspaces[workspaceId] : [];
    const meAclOrgs = (0, store_1.useRootSelector)(({ me }) => me.acl?.organizations, react_redux_1.shallowEqual);
    const organizationId = (0, store_1.useRootSelector)(({ organizationId }) => organizationId, react_redux_1.shallowEqual);
    const aclOrganizations = meAclOrgs && Object.keys(meAclOrgs);
    const currentOrgPermissions = aclOrganizations?.length
        ? meAclOrgs[organizationId ?? 'null']
        : [];
    const orgCanAccess = (permission) => {
        if (typeof permission === 'string') {
            return currentOrgPermissions?.includes(`${permission}`);
        }
        else {
            return currentOrgPermissions?.some((orgPermission) => {
                return Object.values(permission).some((permissionItem) => {
                    return orgPermission === `${permissionItem}`;
                });
            });
        }
    };
    const canRead = (permission) => {
        if (typeof permission === 'string') {
            return (currentWsPermissions?.includes(`${permission}_read`) ||
                currentWsPermissions?.includes(`${permission}_write`));
        }
        else {
            return currentWsPermissions?.some((wsPermission) => {
                return Object.values(permission).some((permissionItem) => {
                    return (wsPermission === `${permissionItem}_read` ||
                        wsPermission === `${permissionItem}_write`);
                });
            });
        }
    };
    const canWrite = (permission) => {
        if (typeof permission === 'string') {
            return currentWsPermissions?.includes(`${permission}_write`);
        }
        else {
            return currentWsPermissions?.some((wsPermission) => {
                return Object.values(permission).some((permissionItem) => {
                    return wsPermission === `${permissionItem}_write`;
                });
            });
        }
    };
    const hasWritePermission = !!defaultPermission && canWrite(defaultPermission);
    const hasReadPermission = !!defaultPermission && canRead(defaultPermission);
    return {
        canRead,
        canWrite,
        hasWritePermission,
        hasReadPermission,
        orgCanAccess,
    };
};
exports.useAccessRole = useAccessRole;
